import {useMyAccessRestriction} from '@/api/access-restriction';
import {useAccessRestrictionModal} from '@/components/AccessRestrictionModalSystem';
import {useSession} from './session';

/**
 * 결제·쿠폰 등록처럼 누르는 시점에 이용 제한을 판정한다.
 * 제한 중이면 안내 모달을 띄우고 true 를 돌려준다 — 호출부는 진행을 멈춘다.
 * 판정 요청이 실패하면 진행시킨다 (서버가 해당 API에서 한 번 더 막는다).
 */
export const useCheckAccessRestriction = () => {
  const {user} = useSession();
  const {refetch, isFetching} = useMyAccessRestriction(user?.id, false);
  const openModal = useAccessRestrictionModal();

  const checkAccessRestriction = async () => {
    const {data: restriction} = await refetch();

    if (restriction) {
      openModal(restriction);
      return true;
    }

    return false;
  };

  return {checkAccessRestriction, isChecking: isFetching};
};
